export default __webpack_public_path__ + "static/media/POPPINS-EXTRABOLDITALIC.7673ce2a.TTF";